import React, { Component } from 'react';

//for connecting
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions/user';

import { Formik } from 'formik';

class Userpage extends Component {

    constructor(props) {
        super(props);
        this.state = {fetched: false, file: {}, fileErr:'', fileLoading: false}
        this.handleFileChange = this.handleFileChange.bind(this)
    }

    handleFileChange(e){
        if( e.target.files[0].type === 'text/csv'){
            this.setState({file: e.target.files[0], fileErr:''});
            this.props.uploadCsv(e.target.files[0], this)
        }else{
            this.setState({file: {}, fileErr:'تنها پسوند .csv مجاز است'});
        }
    }

    componentWillMount(){
        const appData = JSON.parse(localStorage.getItem('appData'));
        if(appData) this.props.getUser(appData.user.phone_number)
    }
  

    render() {
        return (
            <div className="container">
                {(this.props.user.phone_number)?(
                <div>
                    <Formik
                        initialValues={{
                            name: this.props.user.name,
                            email: this.props.user.email,
                            phone_number: this.props.user.phone_number
                        }}
                        validate={ values => {
                            let errors = {};

                            if (!values.email) {
                                errors.email = 'وارد کردن ایمیل اجباری است.'
                            } else 
                            // eslint-disable-next-line
                            if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(values.email)) {
                                errors.email = 'ایمیل وارد شده معتبر نیست.'
                            }
                            if (!values.name) {
                                errors.name = 'وارد کردن نام اجباری است.'
                            }
                            return errors;
                        }}
                        onSubmit = {( values, actions) => {
                            this.props.updateUser(values, actions)
                        }}
                        render = { ({values, errors, touched, handleChange, handleSubmit, isSubmitting}) => (
                            <div className="row">
                                <div className="col-md-3 col-md-push-2">
                                    <h2>اطلاعات کاربری</h2>
                                </div>
                                <div className="col-md-2 col-md-push-5">
                                    <button type="submit" onClick={handleSubmit} className="btn btn-lg btn-fill btn-success btn-block" disabled={isSubmitting}>ذخیره</button>
                                </div>
                                <div className="clearfix"></div>
                                <div className="col-md-8 col-md-push-2 col-sm-12 user-div">
                                    <form name="loginForm" onSubmit={handleSubmit}>
                                        <div className="user-form-content">
                                            <div>
                                                <label>نام</label>
                                                <input type="text" name="name" value={values.name} onChange={handleChange} />
                                                {touched.name && errors.name && <div className="form-error">{errors.name}</div>}
                                            </div>
                                            <div>
                                                <label>ایمیل</label>
                                                <input type="text" name="email" value={values.email} onChange={handleChange} dir="ltr" />
                                                {touched.email && errors.email && <div className="form-error">{errors.email}</div>}
                                            </div>
                                            <div>
                                                <label>شماره موبایل</label>
                                                <input type="text" name="phone" value={values.phone_number} disabled/>
                                            </div>                                    
                                        </div>
                                        <div className="footer text-center">
                                        </div>
                                    </form>
                                    <hr/>
                                </div>
                            </div>
                    )}/>
                    <div className="row">
                        <div className="col-md-6 col-md-push-2">
                            <h3>ورود زمان ها از طریق خروجی تاگل</h3>
                        </div>
                        <div className="col-md-2 col-md-push-2">
                            {(!this.state.fileLoading)?
                            (<label className="input-file">
                                انتخاب فایل
                                <input type="file" name="file" id="file" accept="text/csv" onChange={this.handleFileChange} />
                            </label>):
                            (<button type="submit" className="btn btn-lg btn-fill btn-info btn-block" disabled>ارسال فایل ...</button>)
                            }
                        </div>
                        <div className="clearfix"></div>
                        <div className="col-md-6 col-md-push-3">
                            <p className="form-error">
                                {this.state.fileErr}
                            </p>
                        </div>
                    </div>
                </div>
                ):(null)}
                
            </div>
        );
    }
    }

function mapStateToProps(state) {
  return {
    app: state.app,
    user: state.user
    }
}

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}
  
export default connect(mapStateToProps, mapDispachToProps)(Userpage);